/**
 * Stytch Password Authentication Hooks
 *
 * Low-level wrappers for password operations using the Stytch B2B headless client.
 */
import { getStytchClient } from './../client/headless-client';
/**
 * Hook to reset a member's password using an email reset token.
 *
 * Note: the B2B `resetByEmail` option key is `password_reset_token` (not `token`).
 * On success the SDK sets the Stytch session cookies and the member is authenticated.
 */
export function useResetPasswordByEmail() {
    const stytch = getStytchClient();
    return async (passwordResetToken, password, sessionDurationMinutes = 5000) => {
        try {
            if (!stytch) {
                return {
                    success: false,
                    error: 'Stytch client not ready',
                    data: null,
                };
            }
            const result = await stytch.passwords.resetByEmail({
                password_reset_token: passwordResetToken,
                password,
                session_duration_minutes: sessionDurationMinutes,
            });
            return {
                success: true,
                memberAuthenticated: result.member_authenticated,
                intermediateSessionToken: result.intermediate_session_token,
                organizationId: result.organization?.organization_id,
                data: result,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to reset password',
                data: error,
            };
        }
    };
}
